import { GoogleLogin, CredentialResponse } from '@react-oauth/google';
import { useAuth } from '../../contexts/AuthContext';
import Modal from '../common/Modal';

interface SignInModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function SignInModal({ isOpen, onClose }: SignInModalProps) {
  const { loginWithIdToken, error, clearError } = useAuth();

  const handleGoogleSuccess = async (credentialResponse: CredentialResponse) => {
    clearError();

    if (!credentialResponse.credential) {
      console.error('No credential received from Google');
      return;
    }

    try {
      await loginWithIdToken(credentialResponse.credential, 'google');
      // Close modal after successful login
      onClose();
    } catch (err) {
      console.error('Login failed:', err);
      // Error is handled by AuthContext
    }
  };

  const handleGoogleError = () => {
    console.error('Google login failed');
    // User cancelled or error occurred - no need to show error message
  };

  const handleClose = () => {
    clearError();
    onClose();
  };

  return (
    <Modal isOpen={isOpen} onClose={handleClose} title="登入">
      <div className="space-y-4">
        <p className="text-gray-600">使用 Google 帳號登入</p>

        {/* Error message display */}
        {error && (
          <div className="p-3 bg-red-50 border border-red-200 rounded text-red-700 text-sm">
            {error}
          </div>
        )}

        {/* Google Sign In Button */}
        <div className="flex justify-center">
          <GoogleLogin
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
            useOneTap={false}
            theme="outline"
            size="large"
            text="signin_with"
            locale="zh_TW"
          />
        </div>

        <p className="text-xs text-gray-500 text-center mt-4">
          登入即表示您同意我們的服務條款和隱私政策
        </p>
      </div>
    </Modal>
  );
}
